export default __webpack_public_path__ + "206179cb0a0f233917df27e280d2711a.svg";